// extracted by mini-css-extract-plugin
module.exports = {"numberedContent":"_3F6K9k9Y","number":"_1Vd209T5","numberMobile":"_2CK5Zp2g","title":"_3IjSC_cQ","container":"_28ghTWPw","text":"_7Qe7oWqC"};